import {
	Directive,
	ElementRef,
	OnInit,
	inject,
	reflectComponentType,
} from '@angular/core'

const MAX_ELEVATION = 24
const ELEVATION_INCREMENT = 4

@Directive({
	selector: 'mat-card',
	standalone: false,
})
export class AutoCardElevationDirective implements OnInit {
	private parent = inject(AutoCardElevationDirective, {
		skipSelf: true,
		optional: true,
	})
	private elementRef: ElementRef<HTMLElement> = inject(ElementRef)
	private _elevation: number | undefined
	private hasElevationAttribute: boolean = false

	constructor() {
		console.log('AutoCardElevationDirective constructor')
	}
	getElevation(): number {
		if (this._elevation === undefined) {
			this._elevation = this.parent
				? Math.min(
						this.parent.getElevation() + ELEVATION_INCREMENT,
						MAX_ELEVATION,
					)
				: ELEVATION_INCREMENT
		}
		return this._elevation
	}

	ngOnInit(): void {
		const classList = this.elementRef.nativeElement.classList
		const elevationAttribute = Array.from(classList).find((cls) =>
			cls.startsWith('mat-elevation-z'),
		)
		this.hasElevationAttribute = !!elevationAttribute
		if (this.hasElevationAttribute) {
			this._elevation = parseInt(
				elevationAttribute.replace('mat-elevation-z', ''),
			)
		} else {
			this.elementRef.nativeElement.classList.add(
				`mat-elevation-z${this.getElevation()}`,
			)
		}
	}
}
